import SizeBox from 'components/common/SizeBox';
import { TABLET_MAX_WIDTH } from 'constants';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

const WelcomeMobilePopup = ({
  isOpen,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  renderBannerImage,
  renderParagraphWrap,
  renderBesidesWrap,
  renderRegisterRequireWrap,
  renderButtonsWrap,
  renderContactUsWrap,
}) => {
  return (
    <>
      <style>
        {zIndexModal
          ? `
            @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
              .modal {
                z-index: ${zIndexModal || 1101};
              }
            }
          `
          : ``}

        {isBackdropOverlap
          ? `
            .welcome-mobile-modal-backdrop {
              z-index: ${zIndexBackdropOverlap || 1100}!important;
              background: #212121;
              opacity: 0.7!important;
              display: initial!important;
            }
          `
          : `
            .welcome-mobile-modal-backdrop {
              z-index: 1;
              background: #fff;
              opacity: 1!important;
              display: initial!important;
            }
          `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="welcome-mobile-modal-backdrop"
      >
        <ModalBody>
          <GridLayout>
            <GridItem>{renderBannerImage()}</GridItem>
            <GridItem
              style={{
                borderRadius: '20px 20px 0 0',
                marginTop: '-20px',
                padding: '16px 24px',
              }}
            >
              {renderParagraphWrap()}
              <SizeBox height={12} />
              {renderBesidesWrap()}
              <SizeBox height={12} />
              {renderRegisterRequireWrap()}
              <SizeBox height={76} />
              <Divider />
              <SizeBox height={16} />
              {renderContactUsWrap()}
            </GridItem>
          </GridLayout>
        </ModalBody>
        <ModalFooter>{renderButtonsWrap()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  padding: 0 !important;
  & .modal-dialog {
    transform: none;
    margin: 0;
    & .modal-content {
      padding: 0px;
      border-radius: 0px;
      box-shadow: none;
      background: var(--ds-c-white);
      width: 100%;
      height: fit-content
      margin-inline: auto;
      border: none;
      top: 70px;
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  padding-bottom: 70px;
  text-align: left;
`;
const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 0px;
`;
const GridItem = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;

  ${(props) =>
    props.$isCenter &&
    `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  `}
`;

const ModalFooter = styled(Modal.Footer)`
  height: 70px;
  width: 100%;
  background: var(--ds-c-white);
  position: fixed;
  bottom: 0;
  z-index: 1;
  border-top: 1px solid var(--ds-c-grey-disabled);
  border-radius: 0;
`;

const Divider = styled.div`
  height: 1px;
  border-top: 1px dashed #7a8189;
  margin-inline: -8px;
`;

export default WelcomeMobilePopup;
